import React from 'react'

import Home from 'pages/Home'
import Login from 'pages/Login'
import PageNotFound from 'pages/PageNotFound'
import WorkingTables from 'pages/WorkingTables'
import Translations from 'pages/Translations'
import { EXTRA_OUTPUT } from './constants'

const Administration = React.lazy(() => import('pages/Administration'))
const Scenario = React.lazy(() => import('pages/Scenario'))
const Output = React.lazy(() => import('pages/Output'))
const OutputView = React.lazy(() => import('pages/Output/OutputView'))
const ExtraOutput = React.lazy(() => import('pages/ExtraOutput'))
const ExtraOutputView = React.lazy(() =>
  import('pages/ExtraOutput/ExtraOutputView')
)
const InputView = React.lazy(() => import('pages/InputView'))
const TranslationsTable = React.lazy(() => import('pages/TranslationsTable'))

const defaultRoutes = [
  {
    id: 'home',
    path: '/home',
    component: Home,
    title: 'HOME',
    extraProps: ['fallbackRedirectPath'],
    sidebar: false,
    contentPadding: false
  },
  {
    title: 'MASTERDATA',
    id: 'instances',
    path: '/instances/:instanceId/workingtables',
    sidebar: true,
    header: true,
    component: WorkingTables,
    expandSidebar: true,
    routes: [
      {
        id: 'document',
        path: '/:workingTableId/:type/documents',
        sidebar: true,
        expandSidebar: true,
        component: InputView,
        title: 'MASTERDATA',
        extraProps: ['defaultValueGetter', 'wizardComponents'],
        breadcrumbsType: 'inputView' // TODO: da definire meglio
      }
    ]
  },
  {
    title: 'TRANSLATIONS',
    id: 'translations',
    path: '/translations/translationTables',
    sidebar: true,
    header: false,
    component: Translations,
    expandSidebar: true,
    routes: [
      {
        id: 'translationTable',
        path: '/:group/:type/documents',
        sidebar: true,
        expandSidebar: true,
        component: TranslationsTable,
        title: 'TRANSLATIONS',
        breadcrumbsType: 'translationsView' // TODO: da definire meglio
      }
    ]
  },
  {
    title: 'SCENARIO',
    id: 'scenario',
    path: '/scenario/:detailView',
    component: Scenario,
    href: '/scenario/management',
    extraProps: [
      'scenarioActionsConfig',
      'scenarioAllowedStatusForCloning',
      'wizardComponents',
      // Fallback of older versions
      'scenarioWizardComponents'
    ],
    exact: true,
    sidebar: false,
    filterBar: true,
    showSidebarSearch: false,
    header: true,
    contentPadding: false
  },
  {
    title: 'OUTPUT',
    id: 'output',
    path: '/output/:scenarioId',
    component: Output,
    sidebar: false,
    header: false,
    expandSidebar: false,
    contentPadding: false,
    showSidebarSearch: false,
    filterBar: true,
    extraProps: ['outputConfigComponents'],
    routes: [
      {
        id: 'outputView',
        path: '/:view',
        sidebar: false,
        filterBar: true,
        expandSidebar: false,
        contentPadding: false,
        showSidebarSearch: false,
        component: OutputView,
        title: 'TBD',
        titleParam: 'view',
        extraProps: ['outputConfigComponents'],
        contentWrapperClassname: 'output-view-main-content'
      }
    ]
  },
  {
    title: 'EXTRAOUTPUT',
    id: EXTRA_OUTPUT,
    path: `/${EXTRA_OUTPUT}`,
    component: ExtraOutput,
    sidebar: false,
    header: true,
    expandSidebar: false,
    contentPadding: false,
    showSidebarSearch: false,
    filterBar: true,
    extraProps: ['outputConfigComponents'],
    routes: [
      {
        id: `${EXTRA_OUTPUT}View`,
        path: '/:view',
        href: `/${EXTRA_OUTPUT}/:view`,
        sidebar: false,
        filterBar: true,
        expandSidebar: true,
        contentPadding: false,
        showSidebarSearch: false,
        component: ExtraOutputView,
        title: 'TBD',
        titleParam: 'view',
        extraProps: ['outputConfigComponents'],
        contentWrapperClassname: 'output-view-main-content'
      }
    ]
  },
  {
    id: 'admin',
    path: '/administration-permissions/:tab',
    href: '/administration-permissions/Roles',
    sidebar: true,
    header: false,
    expandSidebar: false,
    showSidebarSearch: false,
    component: Administration,
    breadcrumbsType: 'administration',
    title: 'ADMINISTRATION'
    // contentWrapperClassname: 'output-view-main-content'
  },
  {
    id: 'login',
    path: '/',
    exact: true,
    public: true,
    component: Login,
    extraProps: [
      'languagesMenuConfig',
      'fallbackRedirectPath',
      'forceRedirectPath'
    ],
    shell: false,
    sidebar: false,
    contentPadding: false
  },
  {
    id: '404',
    public: true,
    component: PageNotFound,
    shell: false,
    title: 'NOTFOUND'
  }
]

export default defaultRoutes
